import { trackAnalyticsEvent } from '@jsmdg/tracking';

function trackEmailClicked(): void {
    setTimeout(() => {
        trackAnalyticsEvent({
            category: 'ProductDetail',
            action: 'TextClick',
            label: 'B2B_Mail',
        });
    }, 0);
}

function trackPhoneNumberClicked(label: string): void {
    if (label) {
        setTimeout(() => {
            trackAnalyticsEvent({
                category: 'ProductDetail',
                action: 'TextClick',
                label,
            });
        }, 0);
    }
}

export { trackEmailClicked, trackPhoneNumberClicked };
